import type { MailboxInfo } from 'owa-client-types';
import copilotSettingsStore from '../store/store';
import { UserType } from '../services/types/serviceSettingTypes';

export default function isAIX00User(mailboxInfo: MailboxInfo) {
    const store = copilotSettingsStore(mailboxInfo);
    return store?.userTypes ? store.userTypes.includes(UserType.AIX00) : false;
}
